/** Parse one complete SSE frame; the transport buffers partial chunks. */
export function parseConfigurationEventFrame(
  frame: string,
): { event: string; data: any } | null {
  const lines = frame.split("\n");
  const event = lines
    .find((line) => line.startsWith("event:"))
    ?.slice(6)
    .trim();
  const payload = lines
    .filter((line) => line.startsWith("data:"))
    .map((line) => line.slice(5).trimStart())
    .join("\n");
  if (!event || !payload) return null;
  try {
    return { event, data: JSON.parse(payload) };
  } catch {
    return null;
  }
}
